import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import styled, { css } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StatusDotWrapper = styled.div.withConfig({
  displayName: "StatusIndicator__StatusDotWrapper",
  componentId: "sc-7a8b7q-0"
})(({
  theme
}) => css(["position:absolute;inset-block-end:-", ";inset-inline-end:-", ";> *{border-color:", ";border-style:solid;border-width:", ";}"], theme.space['100'], theme.space['200'], theme.color['border-core-on-fill-default'], theme.borderWidth['200']));
const StatusIndicator = ({
  away
}) => {
  /**
   * Status indicators are to be green
   * unless the assigned agent is AWAY
   */

  return /*#__PURE__*/_jsx(StatusDotWrapper, {
    children: /*#__PURE__*/_jsx(StatusDot, {
      use: away ? 'default' : 'success'
    })
  });
};
StatusIndicator.displayName = 'StatusIndicator';
export default StatusIndicator;